












import { User } from "../models/User";

export default {
    name: "UserRolesDisplay",
    props: {
        userData: Object,
    },
    data() {
        return {
            user: null,
        };
    },
    created() {
        this.user = new User(this.userData);
    },
};
